import { IDropdownSearchResponse } from '@/components/common';
import { IFaceIdProfileSearchResponse } from '@/interfaces';
import { ApiResponse } from '@/types';

export const getProfileOptionLabel = (
  profileId?: string,
  fullName?: string,
  employeeId?: string,
): string => {
  if (!profileId || !fullName || !employeeId) return '';
  return `${profileId} - ${fullName} | ${employeeId}`;
};

export const mapFaceIdProfileResponseToDropdownSearchResponse = (
  response: ApiResponse<IFaceIdProfileSearchResponse>,
): IDropdownSearchResponse => {
  return {
    data: response.data.data.map((item) => ({
      value: item.profileId,
      label: getProfileOptionLabel(item.profileId, item.fullName, item.employeeId),
      cursor: item.id,
    })),
    cursor: response.data.metadata?.cursor,
  };
};

export const mapFaceIdProfileResponseToMultiSelectOptions = (
  response: ApiResponse<IFaceIdProfileSearchResponse>,
) => {
  return {
    data: response.data.data.map((item) => ({
      value: item.id,
      label: getProfileOptionLabel(item.profileId, item.fullName, item.employeeId),
      cursor: item.id,
    })),
    cursor: response.data.metadata?.cursor,
  };
};
